import { Injectable } from '@angular/core';
import { AddFilterToParamsUrl } from './add-filter-to-params-url';
import { SearchPageParamsName } from './concat-params';

@Injectable({
  providedIn: 'root'
})
export class AddFilterToParamsUrlService implements AddFilterToParamsUrl {

  public add(
    data: Map<string, Set<number>> | any[],
    params: SearchPageParamsName,
    page: boolean,
    searchSeo: boolean
  ): any[] {

    const addParams = {};
    data.forEach((item, i) => addParams[i] = [...item.values()].join());

    if (searchSeo) {
      return [addParams];
    }

    const queryParams = page ? {
      pattern: params.pattern,
      ...addParams
    } : {
      info: params.info,
      pEnd: params.pEnd,
      pStart: params.pStart,
      pattern: params.pattern,
      sectionId: params.sectionId,
      region: params.region,
      ...addParams
    };

    return [addParams, queryParams];
  }

}
